import { render, staticRenderFns } from "./TreatmentDosage.vue?vue&type=template&id=e0b2ca98&scoped=true&lang=pug&"
import script from "./TreatmentDosage.vue?vue&type=script&lang=js&"
export * from "./TreatmentDosage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b2ca98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
